module.exports = __webpack_public_path__ + "img/v1-login-mobile.ac3246d4.png";